module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Images","noImage":"No images available","noImageSelected":"Select an image"},"no":{"title":"Bilder","noImage":"Ingen tilgjengelige bilder","noImageSelected":"Velg et bilde"}}')
  delete Component.options._Ctor
}
